import React, { useContext, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import {
  NotificationInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../../context";
import { AuditOutlined, CalendarOutlined } from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantWasteDetails from "./MerchantWasteDetails";

const MerchantWaste = ({
  merchantWasteList,
  setMerchantWasteList,
  total,
  setTotal,
}) => {
  const tableLayout = "";
  const scroll = {};
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [search, setSearch] = useState("");
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const navigate = useNavigate();

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Transaction Number",
      dataIndex: "transaction_id",
      sorter: (a, b) => a.transaction_id - b.transaction_id,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Employee",
      // dataIndex: ["transaction_id", ""],
      // sorter: (a, b) => a.transaction_id - b.transaction_id,
      render: (text, record) => (
        <p
          style={{
            // textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text.wasteemployeeinfo.lastname}, {text.wasteemployeeinfo.firstname}
        </p>
      ),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {text.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = merchantWasteList.data.filter((data) => {
    return (
      data.transaction_id.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.wasteemployeeinfo.firstname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0 ||
      data.wasteemployeeinfo.lastname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from)).format("YYYY-MM-DD"),
      date_to: moment(new Date(values.date_to)).format("YYYY-MM-DD"),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/waste-transaction", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setMerchantWasteList({ data, ready: true });
          setTotal(calculateTotal(data));
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].cost) * 1;
    }
    return total;
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search transaction # and employee"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Tooltip title="Filter by date">
          <Button
            icon={<CalendarOutlined />}
            onClick={() => setOpenFilterByDate(true)}
          >
            Filter
          </Button>
        </Tooltip>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.transaction_id}
          summary={() => (
            <Table.Summary fixed={"bottom"}>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4} align="right">
                  <p style={{ fontWeight: "bold" }}>
                    Total:{" "}
                    {total.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                </Table.Summary.Cell>
                <Table.Summary.Cell />
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
      </div>

      {openDrawer && (
        <MerchantWasteDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="waste-filter"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantWaste;
